<div class="form-fields-theme">
    <div class="sign-in-text">Reset Password</div>
    <p class="sign-in-subtext">
        OTP sent to mobile number <span>{{ mobileNumber }}</span>
    </p>
    <form name="resetPassword" [formGroup]="resetPassword" (submit)="reset()">
        <mat-form-field>
            <mat-label>Verification Code</mat-label>
            <input matInput formControlName="code" type="tel" maxlength="6" required
                (keypress)="allowOnlyNumbers($event)" (paste)="allowOnlyNumbers($event)" autocomplete="new-password" />
            <div matSuffix (click)="resendVerificationCode()">
                @if (!enableResendOtp) {
                    <div class="deactive-timer">
                        <span>Resend OTP &nbsp;</span>
                        <span>00:{{ timeDelay }}</span>
                    </div>
                }
                @if (enableResendOtp) {
                    <span class="send-otp">Resend OTP</span>
                }
            </div>
            @if (resetPassword.get('code').hasError('required')) {
                <mat-error> Please enter OTP </mat-error>
            }
        </mat-form-field>

        <mat-form-field>
            <mat-label>New Password</mat-label>
            <input matInput formControlName="password" type="password" autocomplete="new-password" required />
            @if (resetPassword.get('password').hasError('required')) {
            <mat-error>
                Password is <strong>required</strong>
            </mat-error>
            }
            @if (resetPassword.get('password').hasError('minlength')) {
            <mat-error>
                Confirm Password is too short <i>(minimum is 6 characters)</i>
            </mat-error>
            }
        </mat-form-field>

        <mat-form-field>
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="confirm_password" type="password" required />
            @if (resetPassword.get('confirm_password').hasError('required')) {
            <mat-error>
                Confirm password is <strong>required</strong>
            </mat-error>
            }
            @if (resetPassword.get('confirm_password').hasError('passwordMismatch') &&
            resetPassword.get('confirm_password').touched) {
            <mat-error>
                Passwords do not match
            </mat-error>
            }
        </mat-form-field>

        <input type="submit" style="position: absolute; left: -9999px" />
    </form>
</div>

<div class="clearfix"></div>

<div class="row">
    <div class="col-sm-12 mb-10">
        <button btn-primary size="full" (click)="reset()" class="submit-button" [isLoading]="btnLoading">SUBMIT</button>
    </div>
</div>